export const EDIT_CHECKED1 = 'EDIT_CHECKED1'
export const EDIT_CHECKED2 = 'EDIT_CHECKED2'
export const ADD_DATA = 'ADD_DATA'
export const EDIT_LIST1 = 'EDIT_LIST1'
export const ADD_LIST1 = 'ADD_LIST1'
export const DELETE_LIST1 = 'DELETE_LIST1'
export const REMOVE_ID = 'REMOVE_ID'
export const ADD_LIST2 = 'ADD_LIST2'
export const DELETE_LIST2 = 'DELETE_LIST2'
export const CHECK_LIST1 = 'CHECK_LIST1'
export const CHECK_LIST2 = 'CHECK_LIST2'
export const SAVE_DATA = 'SAVE_DATA'

export const DELETE_DATA = 'DELETE_DATA'

export const INSERT_SERVICE = 'INSERT_SERVICE'
export const DELETE_SERVICE = 'DELETE_SERVICE'
export const UPDATE_SERVICE = 'UPDATE_SERVICE'
export const WRITETODB_SERVICE = 'WRITETODB_SERVICE'

export const INSERT_SERVICEPACKAGE = 'INSERT_SERVICEPACKAGE'
export const DELETE_SERVICEPACKAGE = 'DELETE_SERVICEPACKAGE'
export const UPDATE_SERVICEPACKAGE = 'UPDATE_SERVICEPACKAGE'
export const WRITETODB_SERVICEPACKAGE = 'WRITETODB_SERVICEPACKAGE'

export const INSERT_SERVICEQUESTION = 'INSERT_SERVICEQUESTION'
export const DELETE_SERVICEQUESTION = 'DELETE_SERVICEQUESTION'
export const UPDATE_SERVICEQUESTION = 'UPDATE_SERVICEQUESTION'
export const WRITETODB_SERVICEQUESTION = 'WRITETODB_SERVICEQUESTION'

export const INSERT_PHASE = 'INSERT_PHASE'
export const DELETE_PHASE = 'DELETE_PHASE'
export const UPDATE_PHASE = 'UPDATE_PHASE'
export const WRITETODB_PHASE = 'WRITETODB_PHASE'

export const INSERT_SERVICEQUESTIONMULTICHOICE = 'INSERT_SERVICEQUESTIONMULTICHOICE'
export const DELETE_SERVICEQUESTIONMULTICHOICE = 'DELETE_SERVICEQUESTIONMULTICHOICE'
export const UPDATE_SERVICEQUESTIONMULTICHOICE = 'UPDATE_SERVICEQUESTIONMULTICHOICE'
export const WRITETODB_SERVICEQUESTIONMULTICHOICE = 'WRITETODB_SERVICEQUESTIONMULTICHOICE'

export const INSERT_SERVICEPACKAGESERVICE = 'INSERT_SERVICEPACKAGESERVICE'
export const DELETE_SERVICEPACKAGESERVICE = 'DELETE_SERVICEPACKAGESERVICE'
export const UPDATE_SERVICEPACKAGESERVICE = 'UPDATE_SERVICEPACKAGESERVICE'
export const WRITETODB_SERVICEPACKAGESERVICE = 'WRITETODB_SERVICEPACKAGESERVICE'

export const INSERT_ORDERLINE = 'INSERT_ORDERLINE'
export const DELETE_ORDERLINE = 'DELETE_ORDERLINE'
export const UPDATE_ORDERLINE = 'UPDATE_ORDERLINE'
export const WRITETODB_ORDERLINE = 'WRITETODB_ORDERLINE'

export const INSERT_ORDERINFO = 'INSERT_ORDERINFO'
export const DELETE_ORDERINFO = 'DELETE_ORDERINFO'
export const UPDATE_ORDERINFO = 'UPDATE_ORDERINFO'
export const WRITETODB_ORDERINFO = 'WRITETODB_ORDERINFO'

export const CREATE_ERROR = 'CREATE_ERROR'